import React from 'react';
import {
  Paper,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Divider,
} from '@mui/material';
import {
  AddOutlined as AddIcon,
  EditOutlined as EditIcon,
  PersonAddOutlined as PersonAddIcon,
  EventOutlined as EventIcon,
} from '@mui/icons-material';

const ActivityTab = ({ committee }) => {
  const getActivityIcon = (action) => {
    if (action.includes('created')) return <AddIcon />;
    if (action.includes('edited') || action.includes('updated')) return <EditIcon />;
    if (action.includes('Member added') || action.includes('assigned')) return <PersonAddIcon />;
    if (action.includes('Meeting')) return <EventIcon />;
    return <AddIcon />;
  };

  const getActivityColor = (action) => {
    if (action.includes('created')) return '#2E7D32'; // Dark green
    if (action.includes('edited') || action.includes('updated')) return '#1976D2'; // Dark blue
    if (action.includes('Member added') || action.includes('assigned')) return '#424242'; // Dark gray
    if (action.includes('Meeting')) return '#1565C0'; // Dark blue
    return '#616161';
  };

  const getActivityBgColor = (action) => {
    if (action.includes('created')) return '#E8F5E9'; // Light green
    if (action.includes('edited') || action.includes('updated')) return '#E3F2FD'; // Light blue
    if (action.includes('Member added') || action.includes('assigned')) return '#F5F5F5'; // Light gray
    if (action.includes('Meeting')) return '#E3F2FD'; // Light blue
    return '#F5F5F5';
  };

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Activity Log
      </Typography>
      <Divider sx={{ mb: 2 }} />

      {committee.activity && committee.activity.length > 0 ? (
        <List>
          {committee.activity.map((activity, index) => (
            <React.Fragment key={activity.id}>
              <ListItem alignItems="flex-start">
                <ListItemAvatar>
                  <Box
                    sx={{
                      width: 48,
                      height: 48,
                      borderRadius: '50%',
                      bgcolor: getActivityBgColor(activity.action),
                      color: getActivityColor(activity.action),
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    {getActivityIcon(activity.action)}
                  </Box>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Typography variant="body2" fontWeight={500}>
                      {activity.action}
                    </Typography>
                  }
                  secondary={
                    <>
                      <Typography variant="caption" component="span" color="textSecondary">
                        by {activity.performedBy}
                      </Typography>
                      <br />
                      <Typography variant="caption" component="span" color="textSecondary">
                        {new Date(activity.timestamp).toLocaleString('en-GB', {
                          day: '2-digit',
                          month: '2-digit',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit',
                        })}
                      </Typography>
                    </>
                  }
                />
              </ListItem>
              {index < committee.activity.length - 1 && <Divider variant="inset" component="li" />}
            </React.Fragment>
          ))}
        </List>
      ) : (
        <Box sx={{ textAlign: 'center', py: 5 }}>
          <Typography variant="body2" color="textSecondary">
            No activity recorded yet
          </Typography>
        </Box>
      )}
    </Paper>
  );
};

export default ActivityTab;
